import { Component, OnInit, OnDestroy } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, UntypedFormControl, Validators } from '@angular/forms';
import { UserMapping } from '../model/usermapping';
import { Observable ,  Subscription } from 'rxjs';
import { startWith ,  map } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { Message } from '../model/message';
import { MatDialogRef } from '@angular/material/dialog';
import { UserMappingService } from '../services/usermapping.service';
import { MessageService } from '../services/message.service';
import { SettingsService } from '../services/settings.service';

@Component({
  selector: 'app-new-message-dialog',
  templateUrl: './new-message-dialog.component.html',
  styleUrls: ['./new-message-dialog.component.css']
})

export class NewMessageDialogComponent implements OnInit, OnDestroy {

  sendToAll: boolean = false;

  usermappings: UserMapping[];
  filteredUserMappings: Observable<UserMapping[]>;

  form: UntypedFormGroup;

  private subscription: Subscription;

  constructor(
    private readonly messageService: MessageService,
    fb: UntypedFormBuilder,
    private readonly toastrService: ToastrService,
    public dialogRef: MatDialogRef<NewMessageDialogComponent>,
    private readonly usermappingService: UserMappingService,
    private readonly settingsService: SettingsService) {

    this.form = fb.group({
      sendToAll: new UntypedFormControl(false),
      userMapping: new UntypedFormControl({ value: '', disabled: false }, Validators.required),
      title: new UntypedFormControl(null),
      body: new UntypedFormControl(null, Validators.required),
      replyRequired: new UntypedFormControl(false)
    });

  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  ngOnInit() {

    this.subscription = this.usermappingService.UserMappings.subscribe(result => this.usermappings = result.toArray());
    this.onChanges();

  }

  onChanges() {

    this.filteredUserMappings = this.form.get("userMapping").valueChanges
      .pipe(
        startWith<string | UserMapping>(''),
        map(value => typeof value === 'string' ? value : value.name),
        map(name => name ? this.filter(name) : this.usermappings.slice())
      );


    this.form.get("sendToAll").valueChanges.subscribe((val: boolean) => {
      console.log("sendToAll", val);

      //this.form.get("userMapping").reset ({ disabled: val });
      if (val === true) {
        this.form.get("userMapping").disable();
        this.form.get("replyRequired").disable();
        //this.form.controls.userMapping.disable();
      } else {
        this.form.get("userMapping").enable();
        this.form.get("replyRequired").enable();
        //this.form.controls.userMapping.enable();
      }
    })

  }

  filter(name: string): UserMapping[] {
    return this.usermappings.filter(option =>
      option.name.toLowerCase().indexOf(name.toLowerCase()) === 0);
  }

  displayFn(userMapping?: UserMapping): string | undefined {
    return userMapping ? userMapping.name : undefined;
  }

  submit() {
    console.log(this.form);
    if (this.form.valid) {
      let message = new Message({
        title: this.form.controls.title.value,
        body: this.form.controls.body.value,
        recipientID: this.form.controls.userMapping.value.id,
        recipientName: this.form.controls.userMapping.value.name,
        airportID: this.settingsService.getCurrentAirport()
      });

      if (this.form.controls.sendToAll.value === true) {
        console.log("sendToAll");
        message.type = '255';
        message.recipientID = null;
        message.recipientName = null;
      } else if (this.form.controls.replyRequired.value === true) {
        console.log("replyRequired");
        message.type = '2';
      } else {
        console.log("normalMessage");
        message.type = '1';
      }

      this.messageService.updateMessage(message).then(result => {
        this.toastrService.success("Meddelande har skickats");
      }, (error) => {
        this.toastrService.error("Fel vid skickande av meddelande");
        console.log("Error on createMessage:", error);
        });
      this.dialogRef.close();
    }

  }



}
